import { Button, Col, Row, Space, Tooltip, Typography } from "antd";
import useUser from "../../../../hooks/useUsers";
import color from "../../../../theme/color";
import { Restonic } from "../../Icon";
import { IconForm } from "../../Icon/index.styled";

interface OutLinkMenuProps {}

export const OutLinkMenu: React.FC<OutLinkMenuProps> = () => {
  const { getAdminInfo } = useUser();
  const user = getAdminInfo();

  return (
    <>
      {user?.repairShopFranchiseType === "기타" && (
        <Row style={{ position: "relative" }}>
          <Col span={24} style={{ padding: "8px 16px" }}>
            <Typography.Text style={{ color: color.gray5 }}>
              추가 서비스
            </Typography.Text>
          </Col>
          <Col span={24} style={{ padding: 0 }}>
            <form
              name="restonic_form"
              action="https://restonicmall.com/bbs/register.php"
              method="post"
              target="_blank"
            >
              <input name="id" hidden value={user.id} />
              <input
                name="cd"
                hidden
                value={process.env.REACT_APP_RESTONIC_CODE}
              />
              <Tooltip
                placement="bottomLeft"
                color={color.gray12}
                getTooltipContainer={() =>
                  document.querySelector("#tooltipPosition") as HTMLDivElement
                }
                overlayStyle={{
                  padding: "0 16px",
                  borderRadius: 6,
                }}
                overlayInnerStyle={{
                  width: 178,
                  padding: 16,
                }}
                title={
                  <Row gutter={[0, 4]}>
                    <Col span={24}>
                      <Typography.Text
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: color.gray4,
                          lineHeight: "18px",
                          wordBreak: "keep-all",
                        }}
                      >
                        삼성전자 제품, 매트리스 등 다양한 제품을{" "}
                        <Typography.Text style={{ color: color.primary3 }}>
                          시중가보다 저렴하게{" "}
                        </Typography.Text>
                        구매하실 수 있어요!
                      </Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Typography.Text
                        style={{
                          fontSize: 12,
                          color: color.gray4,
                          lineHeight: "18px",
                        }}
                      >
                        * 최초 이용 시 회원가입이 필요해요.
                      </Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Typography.Text
                        style={{
                          fontSize: 12,
                          color: color.gray4,
                          lineHeight: "18px",
                        }}
                      >
                        * 레스토닉 복지몰에서 일어나는 상품의 구매 및 환불은
                        타이어픽과 무관해요. 관련한 문의는 레스토닉 복지몰
                        고객센터 (080-593-3377)로 전화해주세요.
                      </Typography.Text>
                    </Col>
                  </Row>
                }
              >
                <Button
                  type="text"
                  htmlType="submit"
                  block
                  style={{ textAlign: "left", padding: 16, height: 56 }}
                >
                  <Space size={10} align="center">
                    <IconForm component={Restonic} style={{ fontSize: 24 }} />
                    <Typography.Text
                      style={{
                        color: color.gray4,
                        fontWeight: 700,
                        lineHeight: "20px",
                      }}
                    >
                      레스토닉 복지몰
                    </Typography.Text>
                  </Space>
                </Button>
              </Tooltip>
            </form>
          </Col>
          <div id="tooltipPosition" />
        </Row>
      )}
    </>
  );
};
